module.exports = __webpack_public_path__ + "static/media/qr-wechat.ab3a3791.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qr-wechat.jpg
// module id = 402
// module chunks = 1